import { getConfig } from '@edx/frontend-platform/config';
import { FormattedMessage } from '@edx/frontend-platform/i18n';

import { ExternalLink } from '@/components/ExternalLink';

const TermsAndConditionsText = () => {
  const { TERMS_OF_SERVICE_URL, PRIVACY_POLICY_URL } = getConfig();

  return (
    <div className="mt-3 mb-0">
      <p style={{ fontSize: '20px' }}>
        <FormattedMessage
          id="checkout.planDetails.termsAndConditions"
          defaultMessage="By submitting your info in the form above, you agree to our {termsOfUseLink} and {privacyNoticeLink}. We may use this info to contact you and/or use data from third parties to personalize your experience"
          description="Terms and conditions text for plan details form"
          values={{
            termsOfUseLink: (
              <ExternalLink href={TERMS_OF_SERVICE_URL}>
                <FormattedMessage
                  id="checkout.planDetails.termsAndConditions.termsOfUse"
                  defaultMessage="Terms of Use"
                  description="Link text for Terms of Use in the plan details terms and conditions text"
                />
              </ExternalLink>
            ),
            privacyNoticeLink: (
              <ExternalLink href={PRIVACY_POLICY_URL}>
                <FormattedMessage
                  id="checkout.planDetails.termsAndConditions.privacyNotice"
                  defaultMessage="Privacy Notice"
                  description="Link text for Privacy Notice in the plan details terms and conditions text"
                />
              </ExternalLink>
            ),
          }}
        />
      </p>
    </div>
  );
};

export default TermsAndConditionsText;
